import { useMemo } from "react";

import { type GetOrganizationsQuery } from "../../shared/api/queries";
import { type KeyedOption } from "../../shared/models";
import { type GetAllPreSubmissionInfoWithOrgResourcesQuery } from "../api/queries";
import { sortOrganizationsAvailableForLensSpaceCreation } from "../components/lens-space/sortOrganizationsAvailableForLensSpaceCreation";

export const useOrganizationOptions = (
    data: GetOrganizationsQuery | GetAllPreSubmissionInfoWithOrgResourcesQuery | undefined,
    defaultOrganizationId: string | undefined,
): KeyedOption[] => {
    return useMemo(() => {
        if (!data) return [];
        const sortedOrganizations = sortOrganizationsAvailableForLensSpaceCreation(
            data.getMyLensesOrganizations.organizationsList,
            defaultOrganizationId ?? "",
        );
        return sortedOrganizations.map((organization) => ({
            key: organization.id,
            value: organization.id,
            label: organization.name,
        }));
    }, [data, defaultOrganizationId]);
};
